import { Dispatch, SetStateAction, createContext, useContext } from 'react';
import { AddressWithUnom } from '../@types/address';
import { AddressListActions, AddressListState } from './useAddressListReducer';
import { CheckDataStatus } from '../@types/checkData';
import { GetAddressParams } from '../api/address';

export { AddressListActions };

export type DataContextValue = {
  checkDataStatus: CheckDataStatus;
  selectedAddress: AddressWithUnom | null;
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
  setCheckDataStatus: Dispatch<SetStateAction<CheckDataStatus>>;
  onSelectValidAddress: (address: AddressWithUnom) => void;
  resetSelectedAddress: () => void;
  debouncedGetAddress: (params: Omit<GetAddressParams, 'signal'>) => void;
  abortGetAddress: () => void;
} & AddressListState;

export const DataContext = createContext<DataContextValue | null>(null);
export const useDataContext = () => useContext(DataContext)!;
